module.exports = __webpack_public_path__ + "static/img/color.94add730.jpg";